var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasShown && _vm.isMobile)?_c('div',{staticClass:"drawer"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"drawer__text"},[_vm._v("Add hozzá a főképernyődhöz")])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"drawer__icon"},[_c('img',{staticClass:"drawer__icon__image",attrs:{"src":require("../assets/app_icon_256x256px.png"),"alt":"MELOSTOCK"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45280ced","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeScreenDrawer.vue
// module id = 903
// module chunks = 93